export default __webpack_public_path__ + "static/media/file-icon.85c28446.svg";